import { GetterTree } from "vuex";
import { StateInterface } from "src/store";
import { IdomMemStateInterface } from "./state";

const getters: GetterTree<IdomMemStateInterface, StateInterface> = {
  getSettings(state) {
    return state.settings;
  },
  getCounts(state) {
    return state.counts;
  },
  getLoading(state) {
    return state.loading;
  },
  getGptPhrases(state) {
    return state.gptPhrases;
  },
  getLoadingGpt(state) {
    return state.loadingGpt;
  },
};

export default getters;
